import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({ account, accounts, navigation, sponsors, params = {} }) {
  const handleDelete = useDeleteWithConfirmation('/manage/sponsors')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div className="flex items-center">
          {item.logo_url && (
            <img
              src={item.logo_url}
              alt={item.name}
              className="h-10 w-10 rounded-lg object-contain bg-gray-100 mr-3"
            />
          )}
          <div>
            <div className="font-medium text-gray-900">{value}</div>
            {item.url && <div className="text-sm text-sky-600">{item.url}</div>}
          </div>
        </div>
      )
    },
    {
      key: 'short_description',
      label: 'Description',
      className: 'text-gray-500',
      render: (value) => (
        <span className="truncate max-w-md block">{value || '—'}</span>
      )
    }
  ]

  return (
    <Layout account={account} accounts={accounts} navigation={navigation} title="Sponsors">
      <ResourceIndexHeader
        count={sponsors.length}
        singular="sponsor"
        plural="sponsors"
        addHref="/manage/sponsors/new"
        addLabel="Add Sponsor"
      />

      <DataTable
        data={sponsors}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/sponsors/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search sponsors..."
        emptyState={{
          message: 'No sponsors yet',
          action: { label: 'Add your first sponsor', href: '/manage/sponsors/new' }
        }}
        baseUrl="/manage/sponsors"
        params={params}
      />
    </Layout>
  )
}
